import BaseCommand from "@/models/api/commands/BaseCommand";

export class SetOrderProjectIdCommand extends BaseCommand {
  CommandName = "SetOrderProjectId";
  Command: string;
  constructor(sessionId: string, operationId: string, projectIdToSet: string) {
    super(sessionId, operationId);
    this.Command = projectIdToSet;
  }
}
